import styled from 'styled-components';
import TitleSmall from '../title/TitleSmall';
import Button from '../button/Button';
import Description from '../text/Description';
import '../styles/FadeInFromBottom.css'
import FadeInFromBottom from '../shared/FadeInFromBottom';

const Wrapper = styled.div`
    padding: 7px 0 40px;

  .product-image {
    width: 100%;
    height: auto;
    margin: 20px 0;
  }
`;

const ProductCard = (props) => {
  return (
    <Wrapper>
      <TitleSmall title={props.title}/>
      <FadeInFromBottom>
        <img className="product-image" src={props.image} alt={props.title}/>
      </FadeInFromBottom>
      {props.description && (
        props.description.map((line, index) => (
            <Description key={index} text={line} />
        ))
      )}
      <Button 
        url={props.url}
        buttonText={props.buttonText}
      />
    </Wrapper>
  );
};
  
export default ProductCard;
  